import { z } from 'zod';

const optionalText = (max: number) => z.string().trim().max(max).optional();
const digits = z.string().regex(/^\d*$/u, 'Use somente números.');

/** Instruções para pagamento externo; não representam pagamento nem autorização bancária. */
export const paymentInstructionsSchema = z.discriminatedUnion('method', [
  z
    .object({
      method: z.literal('PIX'),
      key: optionalText(160),
      copyPaste: optionalText(4096),
    })
    .strict(),
  z
    .object({
      method: z.literal('BOLETO'),
      documentNumber: optionalText(160),
      barcode: digits
        .refine(
          (value) => value === '' || [44, 47, 48].includes(value.length),
          'Informe um código de 44, 47 ou 48 dígitos.',
        )
        .optional(),
    })
    .strict(),
  z
    .object({
      method: z.literal('TRANSFER'),
      bank: optionalText(160),
      branch: optionalText(30),
      accountNumber: optionalText(40),
      accountType: z.enum(['CHECKING', 'SAVINGS', 'PAYMENT']).optional(),
      holder: optionalText(160),
      holderDocument: digits
        .refine(
          (value) => value === '' || [11, 14].includes(value.length),
          'Informe CPF com 11 ou CNPJ com 14 dígitos.',
        )
        .optional(),
      identification: optionalText(160),
    })
    .strict(),
]);

export type PaymentInstructions = z.infer<typeof paymentInstructionsSchema>;

/** Códigos de cobrança pertencem à ocorrência e nunca viram padrão de uma família. */
export const recurringPaymentInstructionsSchema = paymentInstructionsSchema.refine(
  (value) =>
    value.method === 'TRANSFER' ||
    (value.method === 'PIX' ? !value.copyPaste : !value.barcode && !value.documentNumber),
  'Cadastre o código de cobrança na despesa do mês, não na recorrência.',
);
